module.exports = __webpack_public_path__ + "img/dead-tree-desert-03.b4d0855e.png";